// @flow

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation, Trans } from '@i18n';
import {
  createCandidate,
  resetCandidateCreate
} from '@redux/components/CandidateCreate/actions';
import type { GlobalState } from '@globalTypes';
import { getInternationalPhone } from '@services/phone';
import { withRouter } from 'next/router';
import { ThankYou } from '@images/svg/index';
import Grid from 'styled-components-grid';
import { withFormik } from '@lib';
import { FastField, Field } from 'formik';
import InputPhone from '@components/InputPhone';
import ButtonRadio from '@components/ButtonRadio';
import Checkbox from '@components/Checkbox';
import compose from 'lodash/fp/compose';
import Input from '@components/Input';
import { isEmpty } from 'lodash';
import { PhoneCode } from '@components/ContactPageNew/countryCode';
import { StyledLabelNew } from '@styles/labels';
import { StyledInput } from '@styles/inputs';
import { phone } from 'phone';
import {
  StyledMiniFlowWrapper,
  StyledContentTop,
  StyledFormGrid,
  StyledRadioGroup,
  StyledItem,
  TermsAndConditionsWrapper,
  StyledLabelTextWrapper,
  StyledButtonSubmit,
  StyledItemSpacing,
  StyledFirstName,
  StyledLastName,
  StyledName,
  StyledPhone,
  StyledValidationMessage,
  StyledEmailFormUnit,
  StyledThankYou
} from './styles';

const Form = ({
  t,
  formName,
  setFieldValue,
  values,
  isModal,
  sending,
  handleSubmit,
  curefyDomain,
  setModalSlide,
  modalSlide,
}) => {
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const formDoctor = true;
  useEffect(() => {
    fetch('https://ipapi.co/json')
      .then(res => res.json())
      .then((response) => {
        // eslint-disable-next-line no-unused-expressions
        response.city && setFieldValue('address_city', response.city || '');
        const internationalPhone: string = getInternationalPhone(
          PhoneCode[response.country_code],
          ''
        );
        // eslint-disable-next-line no-unused-expressions
        response.country_code && setFieldValue('phone', internationalPhone || '');
        // eslint-disable-next-line no-unused-expressions
        response.country_name && setFieldValue('country', response.country_name || '');
      })
      .catch(() => {});
  }, [resetCandidateCreate]);
  const withFormId = key => `${formName}-${key}`;
  const handlePhoneChange = (value, data, event, formattedValue) => {
    setFieldValue('phone', formattedValue);
    if (data.countryCode) {
      setFieldValue('phone_code', data.countryCode.toUpperCase());
    }
    if (!values.country) {
      setFieldValue('country', data.name);
    }
  };

  const [validateMessage, setValidateMessage] = useState(false);
  useEffect(() => {
    if (phone(values.phone).isValid) {
      setValidateMessage(false);
    }
  }, [values.phone]);
  const isAnyValueEmpty: boolean = mandatoryFields.some(fieldName => isEmpty(values[fieldName]));


  if (modalSlide === 1) {
    return (
      <StyledThankYou>
        <ThankYou />
        {t('ThankYouMessage')}
      </StyledThankYou>
    );
  }

  return (
    <StyledMiniFlowWrapper finderForm="FinderForm" formName={formName} domain={curefyDomain}>
      <StyledFormGrid treatmentFormName={formName}>
        <Grid>
          <StyledContentTop>
            <StyledItemSpacing>
              <StyledRadioGroup domain={curefyDomain}>
                <Field
                  name="gender"
                  formValue="male"
                  id={withFormId('male')}
                  component={ButtonRadio}
                  label={t('Mr')}
                />
                <Field
                  name="gender"
                  formValue="female"
                  id={withFormId('female')}
                  component={ButtonRadio}
                  label={t('Ms')}
                />
              </StyledRadioGroup>
            </StyledItemSpacing>
            <StyledName>
              <StyledFirstName treatmentFormName={formName}>
                <StyledLabelNew
                  htmlFor={withFormId('first_name')}
                  finderForm={formName === 'FinderForm'}
                  flowForm={formName === 'MiniFlowForm'}
                  treatmentFormName={formName}
                  campaign
                >
                  {`${t('FirstName')}*`}
                </StyledLabelNew>
                <FastField
                  name="first_name"
                  id={withFormId('first_name')}
                  component={Input}
                  inputComponent={StyledInput}
                />
              </StyledFirstName>
              <StyledLastName treatmentFormName={formName}>
                <StyledLabelNew
                  campaign
                  treatmentFormName={formName}
                  htmlFor={withFormId('last_name')}
                  finderForm={formName === 'FinderForm'}
                  flowForm={formName === 'MiniFlowForm'}
                >
                  {`${t('LastName')}*`}
                </StyledLabelNew>
                <FastField
                  name="last_name"
                  id={withFormId('last_name')}
                  component={Input}
                  inputComponent={StyledInput}
                />
              </StyledLastName>
            </StyledName>

            <StyledEmailFormUnit
              // size=
              treatmentFormName={formName}
            >
              <StyledLabelNew
                campaign
                treatmentFormName={formName}
                htmlFor={withFormId('email')}
                finderForm={formName === 'FinderForm'}
                flowForm={formName === 'MiniFlowForm'}
              >
                {`${t('Email')}*`}
              </StyledLabelNew>
              <FastField
                name="email"
                id={withFormId('email')}
                component={Input}
                displayName={t('Email')}
                inputComponent={StyledInput}
              />
            </StyledEmailFormUnit>

            <StyledPhone>
              <StyledLabelNew
                campaign
                treatmentFormName={formName}
                finderForm={formName === 'FinderForm'}
                flowForm={formName === 'MiniFlowForm'}
              >
                {`${t('PhoneNumber')}*`}
              </StyledLabelNew>
              <FastField name="phone">
                {({ field }) => <InputPhone campaign field={field} onChange={handlePhoneChange} />}
              </FastField>
              <StyledValidationMessage ValidationMessage={validateMessage}>
                {t('ValidationMessage')}
              </StyledValidationMessage>
            </StyledPhone>
            <StyledItem>
              <TermsAndConditionsWrapper treatmentFormName={formName}>
                <Checkbox
                  checked={checkboxChecked}
                  id={withFormId('checkboxTermsAndConditions')}
                  onChange={setCheckboxChecked}
                  treatmentFormName={formName}
                  formDoctor={formDoctor}
                  // smallCheck={isMobile}
                />
                <StyledLabelTextWrapper treatmentFormName={formName}>
                  <Trans i18nKey="ContactPage:ClickTermsAndConditions" />
                </StyledLabelTextWrapper>
              </TermsAndConditionsWrapper>
            </StyledItem>

            <StyledButtonSubmit
              type="submit"
              treatmentFormName={formName}
              disabled={!checkboxChecked
                || isAnyValueEmpty
                || sending
                || !(values.phone && values.phone.length > 6)}
              onClick={() => {
                if (phone(values.phone).isValid) {
                  setModalSlide(1);
                  handleSubmit();
                } else {
                  setValidateMessage(true);
                }
              }}
              isModal={isModal}
            >
              {t('Submit')}
            </StyledButtonSubmit>
          </StyledContentTop>
        </Grid>
      </StyledFormGrid>
    </StyledMiniFlowWrapper>
  );
};

const handleSubmit = (
  formValues,
  {
    props: {
      createCandidate,
      addressCity,
      departments,
      treatment,
      doctor,
      hospital,
      speciality,
      hours,
      time,
      contactUs,
      location,
      contract,
      notes,
      i18n: { language },
    }
  }
): void => {
  createCandidate({
    ...formValues,
    preferred_city: addressCity || formValues.address_city,
    address_city: addressCity || formValues.address_city,
    password: formValues.password,
    notes: notes || formValues.notes,
    treatment: treatment || formValues.treatment,
    modalState: true,
    hours,
    time,
    contactUs,
    location,
    contract,
    departments,
    doctor,
    hospital,
    speciality,
    language,
  });
};

const mapStateToProps = (
  {
    candidateCreate: {
      sending, created, error, created_patient_id, modalCreated
    }
  }: GlobalState,
  props: any
) => ({
  sending,
  created,
  modalCreated,
  error,
  created_patient_id,
  initialFormValues: {
    data: {
      attributes: {
        treatment: props.currentUrl || 'Campaign Treatment',
        department: props.department || '',
        password: props.password,
        address_city: props.addressCity,
        notes: props.campaignName || 'Campaign name',
      }
    }
  },
});

const optionalFields = ['gender', 'treatment', 'medical_summary', 'notes'];
const mandatoryFields = ['first_name', 'last_name', 'phone', 'phone_code'];
const fieldNames = [...optionalFields, ...mandatoryFields];

const mapDispatchToProps = {
  createCandidate,
  resetCandidateCreate,
};

const CampaignForm = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withTranslation('DetailsFacility'),
  withFormik({
    validate: (values) => {
      const errors = {};

      if (!values.phone || !phone(values.phone).isValid) {
        errors.phone = 'Please enter a valid phone number';
      }
      return errors;
    },
    handleSubmit,
    formSubmit: true,
    fieldNames,
    reduxErrorKey: 'error',
    reduxInitialValuesKey: 'initialFormValues'
  })
)(Form);

CampaignForm.getInitialProps = () => ({
  namespacesRequired: ['DetailsFacility'],
});

export default CampaignForm;
